module.exports = __webpack_public_path__ + "img/icon_my.d2b7086.webp";